import axios from 'axios'
import {getENV} from './utils'
import {BASE_PARAMS} from './config'
import {Message} from 'element-ui';
import {tokenCache} from "./cache/Token";

export default function (service, data, method = 'post', loading = true, showError = true) {
  let env = getENV();
  Log(`请求 ${service}`, data);

  data = Object.assign({}, BASE_PARAMS, data, {service});

  if (tokenCache.get()) {
    data.token = tokenCache.get();
  }


  return new Promise((resolve, reject) => {
    // loading && (load = weuijs.loading('加载中...'));
    loading && (bus.$emit('loading', '加载中...'));
    let axiosConfig = {
      url: `${env.api}`,
      method,
      data,
      headers: {
        sign: 'test'
      }
    };
    axios(axiosConfig).then(res => {
      loading && (bus.$emit('loading', false));
      // loading && load.hide();
      if (res.status == 200) {
        Log(`响应 ${service}`, res.data);
        if (res.data.code !== '0') showError && Message.error({
          message: res.data.msg || '错误代码:' + res.data.code
        });
        resolve(res.data)
      } else {
        Message.error({
          message: '请求失败' + res.status
        });
        reject(res);
      }
    }).catch(errsr => {
      loading && (bus.$emit('loading', false));
      // loading && load.hide();
      Log('error', errsr);
      Message.error({
        message: '服务器出错了'
      });
      reject(errsr);
    })
  })
}
